
import {Component, OnInit} from '@angular/core';
import {AfterViewInit, OnDestroy, ViewChild} from '@angular/core';
import {ApiIntegration} from '../_services/api.integration';
import {Globals} from '../_models/globals';
import {DataTableDirective} from 'angular-datatables';
//import {LocalStorageService, SessionStorageService, LocalStorage, SessionStorage} from 'angular-web-storage';
import {environment} from '../../environments/environment';
import {HttpClient, HttpHeaders, HttpErrorResponse} from '@angular/common/http';
import {Router, ActivatedRoute} from '@angular/router';
import {User} from '../_models/user';
import {Subject} from 'rxjs';
import {Register} from '../_models/register';
import {Product} from '../_models/product';
import {productList} from '../_models/productList';
import {KitComponent} from '../_models/kitComponent';
import * as _ from "lodash";
import {AlertService} from '../_services/alert.service';
import { OrderLine } from '../_models/orderLine';
import { OrderHeader } from '../_models/orderHeader';

@Component({
  selector: 'app-track-return-order',
  templateUrl: './track-return-order.component.html',
  styleUrls: ['./track-return-order.component.scss'],
})
export class TrackReturnOrderComponent implements OnInit {

  stockEntryHeader: any;
  getTrackOrderData: any;
  getCarrierTrackOrderData : any;
  estimatedDelivery: any;
  trackingNumber: any;
  shippingOption: any;
  order: any ={};

  return: boolean = false;

  subject: any;
  description: any;
  orderLines : OrderLine[] = [];
  requests: string = '';
  request: string = '';

  actionInstructions: string;
  needActionReason: string;
  viewCustomer : any={};
  addresses:any;
  actionReasons: any = [];
  timerDisplayValue: string = "30:00";
  reEnterPassword: string = "";
  errorMessage: string = "";
  successMessage: string = "";
  otpError: string = "";


  interval: any;
  str: any;

  reverseArray:any;
  singleStatus:any;
  requestOtp: string = "";
  cancelReason: string;
  trackingMenuList: any;
  track1: any;
  imageUrlMobile: any;
  imageUrl: any;
  resp = {};
  meta = {};
  status : string ;


  constructor(private alertService: AlertService, private http: HttpClient, private router: Router, public route: ActivatedRoute, private api: ApiIntegration, private g: Globals, public user: User, public register: Register) {
   //this.getApi();
   //this.viewPage();
  /*  this.actionReasons = [
     {label: 'Contact information not appropriate', config: 'COMMUNICATION_INFO_ISSUE'},
     {label: 'Issue with Inventory', config: 'STOCK_ISSUE'}
   ]; */


   /* this.g.loaderDisplay = "display";
       this.api.getReturnOrder(this.route.snapshot.params['id']).subscribe((data: any) => {
         this.g.loaderDisplay = "";
         this.order = data;
         this.orderLines = this.order.lines;

       }, err => {
           this.g.loaderDisplay = "";
         this.alertService.error('Error', err);
       }); */
     this.getData();
 }


 getData(){
 this.g.loaderDisplay = "display";
        this.api.getReturnOrder(this.route.snapshot.params['id']).subscribe((data: any) => {
          this.g.loaderDisplay = "";
          this.order = data;
          this.orderLines = this.order.lines;
           this.getTrackMenuList();
           this.getTrackBanner();
           this.trackOrder();
        }, err => {
            this.g.loaderDisplay = "";
          this.alertService.error('Error', err);
        });
        }




  getApi(){
    this.api.getStockTransferDetailsIdPublic(this.route.snapshot.params['id'], "1").subscribe((data: any) => {
        this.order = data;
        this.orderLines = _.cloneDeep(this.order.lines);
        this.g.loaderDisplay = "";
        this.orderLines.forEach((d)=>{
          d['previousQuantity']=d.quantity;
        });
        this.g.loaderDisplay = "";
        this.trackingNumber = data.trackingNumbers;
        this.shippingOption = data.shippingOption;
        this.trackOrder();
        this.g.loaderDisplay = "";
    }, err => {
        console.log(err);
        this.g.loaderDisplay = "";
    });
  }

getTrackMenuList(){
  this.g.loaderDisplay = "display";
  this.api.getTrackingMenuLiPblic(this.order.accountOwnerId, this.user.organizationId).subscribe((data : any) => {
  this.g.loaderDisplay ="";
  this.trackingMenuList = data.trackingMenuList;
  } ,
  err => {
        this.g.loaderDisplay = "";
        this.alertService.error('Error', err);
      });
  }

   getTrackBanner(){
   this.g.loaderDisplay = "display";
     this.api.getTrackingBannerPublic(this.order.accountOwnerId,this.user.organizationId).subscribe((data : any) => {
     this.g.loaderDisplay ="";
     this.track1 = data;
     this.imageUrlMobile = this.track1.mobileBanner;
     this.imageUrl = this.track1.webBanner;
     } ,
     err => {
           this.g.loaderDisplay = "";
           this.alertService.error('Error', err);
         });
   }

  /*  viewPage() {
    this.g.loaderDisplay = "display";
    this.api.getOrderDataByIdPublic(this.route.snapshot.params['id'], this.route.snapshot.params['jhiUserId'],"1").subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.order = data;
      this.status = this.order.orderStatus;
      this.getTrackMenuList();
      this.getTrackBanner();
          this.str = (this.order.mobileNumber);
          this.str = this.str ? this.str.toString().replace(/\d(?=\d{3})/g, "*") : this.str;
      //this.lines = this.order.lines;
      this.trackOrder();
    }, err => {
      console.log(err);
      this.g.loaderDisplay = "";
    });
  } */

  trackingInformation(){
    this.api.getOrderTrackingDetails(this.route.snapshot.params['id']).subscribe((data: any) => {
        this.order = data;
        this.orderLines = _.cloneDeep(this.order.lines);
        this.g.loaderDisplay = "";
        this.orderLines.forEach((d)=>{
          d['previousQuantity']=d.quantity;
        });
        this.g.loaderDisplay = "";
        this.trackingNumber = data.trackingNumbers;
        this.shippingOption = data.shippingOption;
        this.trackOrder();
        this.g.loaderDisplay = "";
    }, err => {
        console.log(err);
        this.g.loaderDisplay = "";
    });
  }

  ngOnInit() {
  }


  trackOrder() {
    this.api.getOrderTrackingDetailsPublic(this.route.snapshot.params['id']).subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.getTrackOrderData = data.trackOrder;
      this.getCarrierTrackOrderData = data.trackCarrierOrder;
      this.estimatedDelivery = data.estimatedDelivery;
      this.reverseArray = data.trackOrder;
      this.singleStatus = this.reverseArray[0].status;

    }, err => {
      console.log(err);
      this.g.loaderDisplay = "";
    });
  }

}

